import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";

import { isSignedIn } from "seneca-common/features/user/state";
import { useRedirectToAppropriateHomepage } from "seneca-common/utils/hooks/routing";

import { linkToAnonymousCourseDiscoveryWithDefaultFilters } from "features/anonymous-pages/course-discovery/links";
import { useIsPlurallApp } from "features/plurall";
import { linkToSignIn } from "features/sign-up/links";

export default function RedirectToAppropriateHomepage() {
  const signedIn = useSelector(isSignedIn);
  const anonymousCourseDiscoveryEnabled = !useIsPlurallApp();

  useRedirectToAppropriateHomepage();

  if (!signedIn) {
    if (anonymousCourseDiscoveryEnabled) {
      return (
        <Redirect to={linkToAnonymousCourseDiscoveryWithDefaultFilters()} />
      );
    } else {
      return <Redirect to={linkToSignIn()} />;
    }
  }

  return null;
}
